export default {
    url: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?',
    response_type: 'code',
    scope: 'user.read openid profile Calendars.Read',
    response_mode: 'fragment',
};
